import cImg1 from '../images/casestudy/img01.jpg'
import cImg2 from '../images/casestudy/img02.jpg'
import cImg3 from '../images/casestudy/img03.jpg'
import cImg4 from '../images/casestudy/img04.jpg'
import cImg5 from '../images/casestudy/img05.jpg'
import cImg6 from '../images/casestudy/img06.jpg'
import cImg7 from '../images/casestudy/img07.jpg'
import cImg8 from '../images/casestudy/img08.jpg'
import cImg9 from '../images/casestudy/img09.jpg'
import cImg10 from '../images/casestudy/img10.jpg'


const caseStudies = [
    { id: 1, category: "cat4", img: cImg1, title: "SEO tracking analysis..", slug: "Branding" },
    { id: 2, category: "cat3", img: cImg2, title: "Online media management..", slug: "Marketing" },
    { id: 3, category: "cat4", img: cImg3, title: "Cloud infrastructure..", slug: "Branding" },
    { id: 4, category: "cat2", img: cImg4, title: "Design system & UI kit..", slug: "Design" },
    { id: 5, category: "cat1", img: cImg5, title: "Offline SEO marketing..", slug: "Development" },
    { id: 6, category: "cat5", img: cImg6, title: "IT security enhancement..", slug: "Support" },
    { id: 7, category: "cat2", img: cImg7, title: "Minimalistic bottle logo concept..", slug: "Design" },
    { id: 8, category: "cat1", img: cImg8, title: "Advanced Link Building..", slug: "Development" },
    { id: 9, category: "cat5", img: cImg9, title: "Keyword Research..", slug: "Strategy" },
    { id: 10, category: "cat4", img: cImg10, title: "Creative Logo Design..", slug: "Branding" },
  ];
export default caseStudies;